<app-navbar [PageType]="navType"></app-navbar>
<div class="body-background">
    <div class="container-box">
        <div class="d-flex cursorn" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
        [routerLink]="['/personal']" [queryParams]="{tag: 'back'}">
            <img src="{{imgSrc}}back-arrow.svg" alt="back-arrow" class="img-fluid">
            <div class="back-to-home">back to previous step</div>
        </div>

        <div class="step2-box">
            <form [formGroup]="AddressForm">
                <div class="d-flex">
                    <div class="address-text">Your Current Address</div>
                   <div class="img-tiptool tooltip">
<img src="{{imgSrc}}info.svg" alt="info-arrow" class="img-i img-fluid"> 
<div class="bottom">
    In order to verify you, please ensure that the address provided matches your accounts, such as bank account or credit card.
<i></i>
</div>
</div>
                </div>

                <div *ngFor="let item of t.controls; let i = index">
                    <div [formGroup]="item">

                        <div class="postcode">Enter Postcode</div>
                        <div class="d-flex">
                            <input type="text" id="post-code" class="from-control margin-neww custom-input" placeholder=""
                            onkeypress="if(this.value.length==8) return false; return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122  || event.charCode == 32 ||  event.charCode>=48 && event.charCode<=57"
                                formControlName="PostCode" autocomplete="off" maxlength="8" pattern="^[A-Za-z0-9 ]*$"
                                (focus)="onfocus(i+1)" [ngClass]="{'is-invalid':Errmsg(i+1) || IsInvalidPostcode(i+1) || (item.controls.PostCode.errors && item.controls.PostCode.touched)}">

                            <div  *ngIf="IsPostcodeLoader(i+1)" class="spinner-border custom-spinner-border-blue"
                                role="status">
                            </div>
                            <button id="btnPostCode" class="btn button-find" type="submit"
                                (click)="FindAddress(item.controls.PostCode.value, (i + 1))">Find Address</button>
                        </div>
                        <div *ngIf="Errmsg(i+1) || IsInvalidPostcode(i+1) || (item.controls.PostCode.errors && item.controls.PostCode.touched)" class="text-danger">
                            <div *ngIf="Errmsg(i+1)">{{Errmsgs(i+1)}}</div>
                            <div *ngIf="IsInvalidPostcode(i+1)">No address found on the requested Postcode</div>
                            <div *ngIf="item.controls.PostCode.errors?.pattern">Please enter valid postcode</div>
                        </div>
                        <div class="link-text" *ngIf="!getlinkDynamicAddress(i)"  (click)="ShowDiv('A',i+1)">Enter the address manually</div>
                        <div class="link-text" *ngIf="getIsShowMannualAddress(i) && getlinkDynamicAddress(i)" (click)="ShowDiv('B',i+1)">I want to search my address using postcode</div>
                        <div class="text-01" *ngIf="getIsAddressShow(i)">What is your address?</div>
                       
                        <div *ngIf="getIsAddressShow(i)">
                        <select  class="select-input form-select option-box select-css" formControlName="AddressId" ngDefaultControl  (change)="onChangeaddress($event,i+1)"
                         (click)="selectAddress($event, i)">
                        <option class="selected-text" selected value='' disabled="">Select</option>
                        <option   class="selected-field select-input form-select" [ngClass]="{'active': add.id == item.controls.AddressId.value || (selectedAddressItem(i+1) == add.id && item.controls.AddressId.value !='')}"
                        *ngFor="let add of getArray(i)" [value]="add.id">{{add.address}}</option>
                      </select></div>
 <div *ngIf="getIsShowMannualAddress(i)">                       
<div class="row">
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="text-01">Flat No.</div>
<div class="custom-m">
<input type="text" formControlName="FlatNumber" class="from-control custom-input" placeholder="" maxlength="16"
[ngClass]="{'is-invalid':item.controls.FlatNumber.errors  && item.controls.FlatNumber.touched}">
<div *ngIf="item.controls.FlatNumber.errors  && item.controls.FlatNumber.touched"  class="text-danger">
    <div *ngIf="item.controls.FlatNumber.errors?.pattern || item.controls.FlatNumber.errors.maxlength">Please enter correct flat number</div>
  </div></div>

</div>
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="text-01">House Name</div>
<div class="custom-m">
<input type="text" formControlName="HouseName" class="from-control custom-input"  minlength="2" maxlength="26" (focusout)="OneHouseRequiredValidation($event,i)" placeholder=""
[ngClass]="{'is-invalid':((item.controls.HouseNo.value=='' && item.controls.HouseName.value =='') && item.controls.HouseName.touched)  || (item.controls.HouseName.touched && item.controls.HouseName.errors)}">
<div *ngIf="(item.controls.HouseNo.value=='' && item.controls.HouseName.value =='') && item.controls.HouseName.touched" class="text-danger">Enter either house name or house number</div>
<div *ngIf="item.controls.HouseName.errors  && item.controls.HouseName.touched"  class="text-danger">
  <div *ngIf="item.controls.HouseName.errors?.pattern || item.controls.HouseName.errors.maxlength">Please enter correct house name</div>
  <div *ngIf="item.controls.HouseName.errors.minlength">House Name should be atleast 2 characters </div>
</div></div>
</div>
</div>
<div class="row">
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="text-01">House Number</div>
<div class="custom-m">
<input type="text" formControlName="HouseNo" class="from-control custom-input" maxlength="10" (focusout)="OneHouseRequiredValidation($event,i)" placeholder=""
[ngClass]="{'is-invalid':((item.controls.HouseNo.value=='' && item.controls.HouseName.value =='') && item.controls.HouseNo.touched)  || (item.controls.HouseNo.errors  && item.controls.HouseNo.touched)}">
<div *ngIf="(item.controls.HouseNo.value=='' && item.controls.HouseName.value =='') && item.controls.HouseNo.touched" class="text-danger">Enter either house number or house name</div>
<div *ngIf="item.controls.HouseNo.errors  && item.controls.HouseNo.touched"  class="text-danger">
  <div *ngIf="item.controls.HouseNo.errors?.pattern || item.controls.HouseNo.errors.maxlength">Please enter correct house number</div>
</div></div></div>
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="text-01">Street</div>
<div class="custom-m">
<input type="text" formControlName="Street" class="from-control custom-input" minlength="2"  maxlength="40" placeholder=""
[ngClass]="{'is-invalid':item.controls.Street.errors  && item.controls.Street.touched}">
<div *ngIf="item.controls.Street.errors  && item.controls.Street.touched" class="text-danger">
    <div *ngIf="item.controls.Street.errors.required">Please enter street</div>
    <div *ngIf="item.controls.Street.errors?.pattern || item.controls.Street.errors.maxlength">Please enter correct street</div>
    <div *ngIf="item.controls.Street.errors.minlength">Street should be atleast 2 characters </div>
  </div></div>
</div>
</div>
<div class="row">
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="text-01">Town</div>
<div class="custom-m">
<input type="text" formControlName="Town" class="from-control custom-input" minlength="2" maxlength="20" placeholder=""
[ngClass]="{'is-invalid':item.controls.Town.errors  && item.controls.Town.touched}">
<div *ngIf="item.controls.Town.errors  && item.controls.Town.touched" class="invalid-feedback">
    <div *ngIf="item.controls.Town.errors.required">Please enter town</div>
    <div *ngIf="item.controls.Town.errors?.pattern || item.controls.Town.errors.maxlength">Please enter correct town</div>
    <div *ngIf="item.controls.Town.errors.minlength">Town should be atleast 2 characters </div>
  </div>
</div>
</div>
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="text-01">County</div>
<div class="custom-m">
<input type="text" formControlName="Country" class="from-control custom-input" minlength="2" maxlength="50" placeholder=""
[ngClass]="{'is-invalid':item.controls.Country.errors  && item.controls.Country.touched}">
<div *ngIf="item.controls.Country.errors  && item.controls.Country.touched"  class="invalid-feedback">
    <div *ngIf="item.controls.Country.errors?.pattern || item.controls.Country.errors.maxlength">Please enter correct County</div>
    <div *ngIf="item.controls.Country.errors.minlength && !item.controls.Country.errors?.pattern">County should be atleast 2 characters </div>
  </div></div>
</div>
</div>
</div>

 <div class="divider"></div>

                        <div class="row">
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div class="text-01">When did you move into this address?</div>
                                <div class="d-flex">
                                    <select name="Month" class="select-input form-select select-css custome-select"
                                        formControlName="Month"
                                        (change)="GetAddressHistory(item.controls.Year.value, $any($event.target).value, i+1)">
                                        <option selected value='' disabled="">Month</option>
                                        <option value='1'>January</option>
                                        <option value='2'>February</option>
                                        <option value='3'>March</option>
                                        <option value='4'>April</option>
                                        <option value='5'>May</option>
                                        <option value='6'>June</option>
                                        <option value='7'>July</option>
                                        <option value='8'>August</option>
                                        <option value='9'>September</option>
                                        <option value='10'>October</option>
                                        <option value='11'>November</option>
                                        <option value='12'>December</option>
                                    </select>
                                    <select class="select-input form-select select-css" formControlName="Year"
                                        name="Year"
                                        (change)="GetAddressHistory($any($event.target).value,item.controls.Month.value, i+1)">
                                        <option selected value='' disabled="">Year</option>
                                        <option *ngFor="let yearvalue of YearStack" [value]="yearvalue.year">
                                            {{yearvalue.year}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-sm-12" [ngClass]="i == 0? 'show':'hide'">
                                <div class="text-01 text09">What’s your residential status?</div>
                                <div>
                                    <select name="ResidentialStatus"
                                        class="select-input form-select select-width select-css"
                                        formcontrolname="ResidentialStatus" (change)="selectResidence($event, i)">
                                        <option selected value='' disabled="">Select</option>
                                        <option *ngFor="let ownership of HomeOwnerStatus; index as i"
                                            [value]="ownership.homeOwnershipId"
                                            [selected]="ownership.homeOwnershipId == item.controls.ResidentialStatus.value">
                                            {{ ownership.homeOwnershipName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="getIsFutureDate(i+1)" id="marginset" class="text-danger">You have entered a future date, please select valid date to continue</div>
                        <div *ngIf="getIsExceededDateFirst(i+1)" id="marginset" class="text-danger">Please select preceding date of stay</div>
                    </div>
                </div>
            </form>
            <div class="d-flex">
                 <!-- TODO: Uncomment the following line when the service is ready -->
                <!-- <button type="button" class="btn button-step" [disabled]="AddressForm.invalid || IsExceededDateFirst || IsExceededDateSec || IsFutureDate || submitted"  (click)="onSubmit()"> -->
                    <button type="button" class="btn button-step" (click)="onSubmit()">
                    <div class="container" *ngIf="IsAddressLoaded">
                        <div style="margin:1% auto;">
                            <div class="spinner-border custom-spinner-border" role="status"></div>
                        </div>
                    </div>
                    <span *ngIf="!IsAddressLoaded">Proceed to Next Step</span>

                </button>
            </div>
            <div class="text-danger text-center">{{AddressMessage}}</div>
        </div>
    </div>
</div>
<app-footer></app-footer>
